import { axiosInstance } from "@/lib/axios";
import queryClient from "@/lib/queryClient";
import { gallerySchema, GalleryType } from "@/schemas/gallery-schema";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

const Gallery = {
  Create: {
    useMutation: (options = {}) =>
      useMutation({
        mutationFn: async (data: GalleryType) => {
          const response = await axiosInstance.post("/api/gallery", data);
          return response.data;
        },
        onSuccess: () => {
          toast.success("Image added to gallery successfully");
          queryClient.invalidateQueries({ queryKey: ["Gallery"] });
        },
        onError: (error: any) => {
          const message = error?.response?.data?.error || "Failed to add image";
          toast.error(message);
        },
        ...options,
      }),
  },

  Get: {
    useQuery: (options = {}) =>
      useQuery({
        queryKey: ["Gallery"],
        queryFn: async () => {
          return (await axiosInstance.get("/api/gallery")).data;
        },
        ...options,
      }),
  },

  Delete: {
    useMutation: (options = {}) =>
      useMutation({
        mutationFn: async (id: string) => {
          return (await axiosInstance.delete(`/api/gallery/${id}`)).data;
        },
        onSuccess: () => {
          toast.success("Image deleted successfully");
          queryClient.invalidateQueries({ queryKey: ["Gallery"] });
        },
        onError: (error: any) => {
          const message =
            error?.response?.data?.error || "Failed to delete image";
          toast.error(message);
        },
        ...options,
      }),
  },
};

export default Gallery;
